import {
  Button,
  Divider,
  Form,
  Input,
  Modal,
  Radio,
  Select,
  Spin,
  Switch,
} from "antd";
import {
  deleteSVG,
  editSVG,
  addSVG,
  salonSVG,
  noticeSVG,
} from "../../assets/settings/SVGs";
import { getLocations } from "../../network/settings";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import ModalAddNewTax from "../../components/settings/modal/ModalAddNewTax";
import ModalEditTax from "../../components/settings/modal/ModalEditTax";
import { useNavigate } from "react-router-dom";
import SalonLocationsSelect from "../../components/common/SalonLocationsSelect";
import { FormattedMessage } from "react-intl";
type Props = {};

const Tips = (props: Props) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  return (
    <div>
      <div className="text-color-primary text-2xl font-semibold leading-7 flex items-center gap-2 text-end">
        <FormattedMessage id="yourCommissionSettingsTitle" />
      </div>
      <div className="my-4 text-color-gray text-base font-normal leading-7 ">
        <FormattedMessage id="addOrEditCommissionDescription" />
      </div>
      <Form form={form}>
        <div className="bg-[#EEF0FF] px-4 py-6 rounded-lg Taxes">
          <div className="bg-white p-4 rounded-lg w-full">
            <div className="mb-4">
              <SalonLocationsSelect />
            </div>
            <div className="flex flex-col items-center justify-between">
              <span className="text-color-primary text-sm mb-4 w-full">
                <FormattedMessage id="currentCommissionValuesLabel" /> :
              </span>
              <div className="flex items-center justify-between w-full">
                <div className="flex max-lg:flex-col items-center gap-6">
                  <div className="flex items-center gap-2">
                    <Select
                      className="!borer-solid !border-[1px] !border-color-primary min-w-[5rem]"
                      defaultValue={1}
                      options={[
                        { value: 1, label: <span>5</span> },
                        { value: 2, label: <span>10</span> },
                        { value: 3, label: <span>15</span> },
                      ]}
                    />
                    <span className="cursor-pointer">{deleteSVG}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Select
                      className="!borer-solid !border-[1px] !border-color-primary min-w-[5rem]"
                      defaultValue={1}
                      options={[
                        { value: 1, label: <span>5</span> },
                        { value: 2, label: <span>10</span> },
                        { value: 3, label: <span>15</span> },
                      ]}
                    />
                    <span className="cursor-pointer">{deleteSVG}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Select
                      className="!borer-solid !border-[1px] !border-color-primary min-w-[5rem]"
                      defaultValue={1}
                      options={[
                        { value: 1, label: <span>5</span> },
                        { value: 2, label: <span>10</span> },
                        { value: 3, label: <span>15</span> },
                      ]}
                    />
                    <span className="cursor-pointer">{deleteSVG}</span>
                  </div>
                </div>
                <Button
                  className="!px-3 !py-2 max-lg:self-start"
                  type="primary"
                >
                  {addSVG}
                </Button>
              </div>
            </div>
            {/* <div className="bg-[#EEF0FF] p-2 rounded-lg flex items-center justify-between my-4">
              <FormattedMessage id="setDefaultSelectionValue" />
              <Select
                className="!borer-solid !border-[1px] !border-color-primary min-w-[5rem]"
                defaultValue={1}
                options={[
                  { value: 1, label: <span>5</span> },
                  { value: 2, label: <span>10</span> },
                  { value: 3, label: <span>15</span> },
                ]}
              />
            </div>
            <Divider className="my-4 border-[2px]" />
            <div className="flex items-center justify-between w-full">
              <div className="text-sm">
                {" "}
                <FormattedMessage id="applySameSettingsAllBranches" />
              </div>
              <Switch />
            </div> */}
          </div>
        </div>
        <div className="flex items-end justify-end text-left gap-4 w-full my-4 mt-8">
          <Button
            type="primary"
            htmlType="submit"
            className="w-fit min-w-[150px] max-w-[150px]"
          >
            <FormattedMessage id="saveChanges" />
          </Button>

          <Button
            type="primary"
            className="btn-primary-not w-fit max-w-[150px] min-w-[150px]"
            onClick={() => navigate(-1)}
          >
            <FormattedMessage id="cancel" />
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default Tips;
